import { c as _c } from "react/compiler-runtime";
import { RemoveMemberSuccessDescription } from "@components/remove-member-success-description";
import { isSuccessResponse } from "@context-providers/error-boundary/error-boundary-utils";
import { useToast } from "@flat-ui";
import { fetchingProjectsFlagsSelector } from "@store/projects/projects-selector";
import { removeMemberFromProject } from "@store/projects/projects-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { ProjectMemberEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * Shared logic for removing a member from a single project: tracks the event,
 * dispatches the removal, and shows a success toast. Callers own their own
 * confirmation dialog and gating (hide vs. disable), and pass tracking props.
 */
export function useRemoveMemberFromProject(t0) {
  const $ = _c(11);
  const {
    companyId,
    project,
    trackingProps,
    onRemoved
  } = t0;
  const dispatch = useAppDispatch();
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    isRemovingProjectMember
  } = useAppSelector(fetchingProjectsFlagsSelector);
  let t1;
  if ($[0] !== companyId || $[1] !== dispatch || $[2] !== onRemoved || $[3] !== openToast || $[4] !== project || $[5] !== trackEvent || $[6] !== trackingProps) {
    t1 = async function removeMember(member) {
      trackEvent({
        name: ProjectMemberEvents.removeMember,
        props: trackingProps
      });
      const result = await dispatch(removeMemberFromProject({
        companyId,
        projectId: project.id,
        member
      }));
      if (!isSuccessResponse(result)) {
        return false;
      }
      openToast({
        title: "Member removed from project",
        message: <RemoveMemberSuccessDescription member={member} subjectType="project" entityName={project.name} />
      });
      onRemoved?.([project.id]);
      return true;
    };
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = onRemoved;
    $[3] = openToast;
    $[4] = project;
    $[5] = trackEvent;
    $[6] = trackingProps;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const removeMember = t1;
  let t2;
  if ($[8] !== isRemovingProjectMember || $[9] !== removeMember) {
    t2 = {
      removeMember,
      isRemovingMember: isRemovingProjectMember
    };
    $[8] = isRemovingProjectMember;
    $[9] = removeMember;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}